<template>
  <div :class="{'isopen':isopen,'showSwtich':showSwtich,'select-form':!hiddenQuery ,'only-select-form':hiddenQuery}">
    <slot></slot>
    <Button class="cxbt-1" type="primary" @click="queryOrderlList" v-if="!hiddenQuery">查询</Button>
    <Button class="cxbt" type="primary" ghost @click="resetSearch" v-if="!hiddenQuery">重置</Button>
    <Button class="dc-btn" @click="exportPolicy" type="primary" ghost v-if="showExport">导出</Button>
    <div class="xl-item" v-if="showSwtich">
      <template v-if="!isopen">
        <Icon type="ios-arrow-down" />
        <span @click="isopen=true" v-if="!isopen">展开查询</span>
      </template>
      <template v-else>
        <Icon type="ios-arrow-up" />
        <span @click="isopen=false">收起查询</span>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: ['showExport', 'hiddenQuery', 'showSwtich'],
  data() {
    return {
      isopen: false,
    }
  },
  watch: {},
  computed: {},
  methods: {
    queryOrderlList() {
      this.$emit('search')
    },
    resetSearch(){
      this.$emit('resetSearch')
    },
    exportPolicy() {
      this.$emit('export')
    },
  },
  created() {},
  mounted() {},
}
</script>
<style lang="scss" scoped>
.select-form {
  width: calc(100% - 195px);
  .cxbt {
    right: -85px;
  }
}
.only-select-form {
  width: 100%;
}
.select-form,
.only-select-form {
  position: relative;
  margin-bottom: 20px;

  &.showSwtich {
    .ivu-form {
      height: 86px;
      overflow: hidden;
    }
    .cxbt,
    .dc-btn {
      bottom: 33px;
    }
  }
  &.isopen {
    .ivu-form {
      height: auto;
      overflow: visible;
    }
  }
  .ivu-form {
    display: flex;
    flex-wrap: wrap;
  }
  /deep/ .ivu-form-item-label {
    word-break: keep-all;
    line-height: 32px;
    padding: 0 12px 0 0;
  }
  /deep/ .ivu-form-item {
    width: 25%;
    display: flex;
    margin: 0;
    &:not(:nth-last-child(-n + 4)) {
      margin-bottom: 25px;
    }
    &:not(:nth-child(4n)) {
      padding-right: 30px;
    }
  }
  /deep/ .ivu-form-item-content {
    width: 100%;
    line-height: 32px;
    margin-left: 0 !important;
    > div {
      width: 100%;
    }
    .ivu-input {
      width: 100%;
      //   line-height: 32px;
    }
    .ivu-date-picker,
    .ivu-checkbox-group,
    .ivu-radio-group,
    .ivu-select,
    .ivu-input-wrapper {
      width: 100%;
    }

    .ivu-date-picker {
      .ivu-input-wrapper {
        width: 100%;
        margin-left: 0;
      }
    }

    .ivu-checkbox-group,
    .ivu-radio-group {
      line-height: 30px;
    }
  }
  @media screen and (max-width: 1400px) {
    /deep/ .ivu-form-item {
      width: 33.3%;
      display: flex;
      margin: 0;
      &:not(:nth-last-child(-n + 3)) {
        margin-bottom: 25px;
      }
      &:not(:nth-child(3n)) {
        padding-right: 30px;
      }
    }
  }
  .cxbt {
    position: absolute;
    right: -210px;
    width: 80px;
    height: 30px;
    bottom: 2px !important;
    padding: 0;
  }
  .cxbt-1 {
    position: absolute;
    right: -120px;
    border: 0;
    width: 80px;
    height: 30px;
    bottom: 2px;
    padding: 0;
  }
  .dc-btn {
    width: 80px;
    height: 30px;
    position: absolute;
    right: -300px;
    bottom: 2px !important;
    padding: 0;
  }
  .xl-item {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    i {
      margin-right: 5px;
    }
    span {
      font-size: 14px;
      color: #666;
    }
  }
}
</style>